import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {NavLink} from 'react-router-dom'
import {AppConfig} from '../../../AppConfig'

// Ссылки верхнего меню сервиса.
export function PublicLinks() {

    return (
        <nav
            className={clsx(
                'top-nav-links ms-lg-3 ms-xxl-6 me-lg-3 me-xl-4',
                'd-flex flex-column align-items-stretch flex-1',
                'col-gap-lg-2 col-gap-xl-3 flex-lg-row align-items-lg-center'
            )}
        >
            <NavLink
                to={appUrl().about}
            >
                {trans().common.top_navigation.about_project}
            </NavLink>
            <NavLink
                to={appUrl().support.rulesAndDocuments}
            >
                {trans().common.top_navigation.rules}
            </NavLink>
            <NavLink
                to={appUrl().support.index}
            >
                {trans().common.top_navigation.support}
            </NavLink>
            {AppConfig.features.news !== false && (
                <NavLink
                    to={appUrl().news.list}
                >
                    {trans().common.top_navigation.news}
                </NavLink>
            )}
        </nav>
    )
}
